import Box from "@mui/system/Box";

export default function Footer() {
  return <Box sx={{ fontSize: 18 }}>&copy; 2024 WhoYouKnow Inc.</Box>;
}
